<template>
  <div class="reports-index">
    <h3 v-if="$route.params.type !== 'TABEL'">Отчеты {{ tr[$route.params.type] }}</h3>
    <h3 v-else>Табель рабочего времени</h3>
    <div class="type-create">
      <div class="create-new">
        <router-link :to="`/dashboard/reports/create/${$route.params.type}`"
                     v-if="isReportEnabledByPlan($store)"
                     class="add-block">
          <el-button type="primary"> + Создать новый отчет</el-button>
        </router-link>
      </div>
      <i v-if="isApprove" class="el-icon-document-checked" @click="showCheck = !showCheck"></i>
      <i class="el-icon-success" @click="updateApprove" v-if="showCheck"></i>
    </div>
    <div class="search-filter">
      <div style="display: flex; flex: 1; width: 100%">
        <el-checkbox style="margin-top: 12px; margin-right: 16px; margin-left: 14px"
                     @input="setChecks"
                     v-model="isCheckedAll" v-if="showCheck"></el-checkbox>
        <el-input
          placeholder="Поиск по номеру отчета" v-model="search" @input="searchInput" class="input-search">
          <el-button slot="append" icon="el-icon-search" @click="fetchReports"></el-button>
        </el-input>
      </div>

      <div style="margin-top: 10px; margin-right: 8px; min-width: 160px;" class="filter-dialog-button">
        <el-dialog
          title="Фильтры"
          :visible.sync="dialogVisibleFilter"
        >
          <el-form>
            <filter-select v-model="filter.status" only-value label="Статус" :options="[
              {
              label: 'Все',
              value: null,
            },
              {
              label: 'Утвержденные',
              value: 'APPROVE',
            },
              {
              label: 'Не утвержденные',
              value: 'NOT_APPROVE',
            }
            ]">
            </filter-select>
            <filter-select v-model="filter.executor" label="Исполнитель"
                           :options="options.filter(({isCompany}) => isCompany)">

            </filter-select>
            <filter-select v-model="filter.user" label="Создатель"
                           :options="options.filter(({isCompany}) => !isCompany)">

            </filter-select>
            <filter-select multiple v-model="filter.objects" label="Объект" :options="objects"></filter-select>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="resetFilter">Сбросить</el-button>
            <el-button type="primary" @click="() => {
              fetchReports()
               this.dialogVisibleFilter = false
            }">Применить</el-button>
          </span>
        </el-dialog>
        <el-button slot="reference" style="width: 100%;" @click="dialogVisibleFilter = true">Фильтры</el-button>
      </div>
      <div class="filter">
        <date-picker
          lang="ru"
          :editable="false"
          ref="datePicker"
          placeholder="Фильтр по дате"
          v-model="filter.datetimeRange"
          @change="changeDateTime"
          range
        ></date-picker>

      </div>
      <a
        v-if="$route.params.type !== 'TABEL'"
        @click="openDialog = true"
        class="filter-btn"
      >
        <el-button type="default">Выгрузить отчет</el-button>
      </a>
      <a v-else class="filter-btn">
        <el-button type="default">Выгрузить отчет</el-button>
      </a>
    </div>
    <div class="reports-ul">
      <router-link
        :to="`/dashboard/reports/create/${report.id}/${report.type}`"
        :key="`${report.id}_${key}`"
        class="reports-li" v-for="(report, key) in reports"
      >
        <div :class="['header-id']">
          <div style="display: flex">
            <el-checkbox
              @click.native.prevent="() => {
                report.isChecked = !report.isChecked
                reports = [...reports]
              }"
              :value="report.isChecked" style="margin-top: 2px" v-if="showCheck"></el-checkbox>
            <span style="margin-left: 4px; margin-right: 4px; pointer-events: none">#{{ report.index }}</span>
            <i style="pointer-events: none" class="el-icon-success" v-if="report.approve"></i>
          </div>
          <span>{{ report.date }}</span>
        </div>
        <span>Пользователь: <strong>{{ report.reporter ? report.reporter.name : report.user.name }}</strong></span>
        <span>Компания: <strong>{{ (report &&  report.user && report.user.company) || '-' }}</strong></span>
        <span v-if="$route.params.type !== 'WILD_PIPE'">Объект: <strong>{{ report.object }}</strong></span>
        <span v-else>Линия: <strong>{{ report.line && report.line.label }}</strong></span>
      </router-link>
    </div>

    <ReportModal :plan="plan" :openDialog="openDialog" @close="openDialog = false"/>
  </div>
</template>

<script>
import firebase from 'firebase';
import dayjs from 'dayjs';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import _ from 'lodash';
import {apiUrl} from '../../../plugins/firebase';
import {formatEndDate, formatStartDate, getCurrentMonth} from "../../../utils/date";
import {getMyCompanyUsers, getPermission, getPermissionByUser, isApprove} from "../../../firestore/permission";
import FilterSelect from "../../../components/FilterSelect";
import {isReportEnabledByPlan} from "../../../utils/permission";
import {getDirOptions} from "../../../firestore/dirs";
import ReportModal from "./components/ReportModal";
import {getObjectOptions} from "../../../firestore/objects";
import {filterObjects} from "../../../utils/filterJobs";

export default {
  name: 'Index',
  components: {ReportModal, FilterSelect, DatePicker},
  data() {
    return {
      isCheckedAll: false,
      dialogVisibleFilter: false,
      objects: [],
      permission: null,
      showCheck: false,
      isApprove: false,
      filter: {
        objects: '',
        executor: '',
        user: '',
        category: '',
        status: {
          label: "Вce",
          value: null
        },
        datetimeRange: [
          new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ],
      },
      plan: {
        isTurn: true,
        isResource: true,
        isFact: true
      },
      lockNavigate: false,
      openDialog: false,
      search: '',
      dayTurn: {
        label: 'Весь день',
        value: null,
      },
      role: 'admin',
      userSelect: {
        label: 'Все пользователи',
        value: null
      },
      options: [],
      tr: {
        COVID: 'по температуре',
        PROF: 'по численности',
        TECH: 'по технике',
        JOB: 'по работам',
        MATERIALS: 'по материалам',
        MAIN: 'общий отчет',
        WILD_PIPE: 'по сварке трубопроводов',
        TABEL: 'Табель рабочего времени'
      },
      reports: [],
    };
  },
  async mounted() {

    this.isApprove = await isApprove(this.$store.state.project.id)
    this.permission = await getPermission(this.$store.state.project.id, this.$store.state.company.uid || firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));

    if (!this.$store.state.project.version) {
      this.permissionUser = await getPermissionByUser(this.$store.state.project.id, firebase.auth().currentUser.uid, (this.$store.state.project.plan && this.$store.state.project.plan.id));
    }

    let filter = localStorage.getItem(this.$route.params.type + '_' + this.$store.state.project.id);


    if (filter) {
      filter = JSON.parse(filter)

      if (!filter.datetimeRange) {
        filter.datetimeRange = []
      }

      this.filter = {
        ...this.filter,
        ...filter,
        datetimeRange: [new Date(dayjs(filter.datetimeRange[0] || null).format('YYYY-MM-DD')), new Date(dayjs(filter.datetimeRange[1] || null).format('YYYY-MM-DD'))]
      }
    }

    if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
      let month = getCurrentMonth(this.$store.state.project.plan.name);
      if (String(month).length === 1) {
        month = '0' + month
      }

      const year = this.$store.state.project.plan.name.split('-')[1]

      const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000

      this.filter.datetimeRange = [new Date(dayjs(unixDateStart).format('YYYY-MM-DD')), new Date(dayjs(unixDateStart)
        .add(1, 'month').subtract(1, 'minute').format('YYYY-MM-DD'))]
    }

    await this.fetchUsers();
    this.userSelect = this.$route.query.user || null
    if (this.userSelect) {
      this.userSelect = JSON.parse(this.userSelect)
    }

    if (this.$route.query.start) {
      this.filter.datetimeRange = [
        new Date(String(this.$route.query.start)),
        new Date(String(this.$route.query.end)),
      ];
    } else if (this.$store.state.project.disableDate) {
      this.filter.datetimeRange = [
        new Date(String(dayjs().subtract(365 * 10, 'days').format('YYYY-MM-DD'))),
        new Date(String(dayjs().format('YYYY-MM-DD'))),
      ];
    }

    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('users')
      .where('uid', '==', firebase.auth().currentUser.uid)
      .get().then(async (response) => {
      await response.forEach((sub) => {
        const data = sub.data();
        if (data) {
          this.role = data.role;
          this.loading = false;
        }
      });

      let query = {}

      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        query.plan = this.$store.state.project.plan.id;
      }


      this.objects = filterObjects((await getObjectOptions(this.$store.state.project.id, this.permission, query)), this.permissionUser)

      this.fetchReports();
      this.fetchUsers();
    });
  },

  watch: {
    '$route.query': {
      handler(response) {
        this.fetchReports();
      },
      deep: true,
    },
    type_select() {
      if (this.type_select === 'DAILY' || this.type_select === 'DAILY_PLAN') {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'day').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      } else {
        this.datetimeRangeDownload = [
          new Date(String(dayjs().utc().subtract(1, 'month').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ]
      }
    }
  },

  methods: {
    disabledRange(time) {
      if (this.$store.state.project.plan && this.$store.state.project.plan.id) {
        let month = getCurrentMonth(this.$store.state.project.plan.name);
        if (String(month).length === 1) {
          month = '0' + month
        }

        const year = this.$store.state.project.plan.name.split('-')[1]
        const unixDateEnd = dayjs(year + '-' + month + '-' + '31' + ' 00:00:00').unix() * 1000

        const unixDateStart = dayjs(year + '-' + month + '-' + '01' + ' 00:00:00').unix() * 1000
        return time.getTime() > unixDateEnd || time.getTime() < unixDateStart;
      } else {
        return false
      }
    },
    resetFilter() {
      this.filter = {
        objects: '',
        executor: '',
        user: '',
        category: '',
        datetimeRange: [
          new Date(String(dayjs().utc().subtract(10, 'days').format('YYYY-MM-DD'))),
          new Date(String(dayjs().utc().format('YYYY-MM-DD'))),
        ],
        status: {
          label: "",
          value: null
        },
      }
      localStorage.removeItem(this.$route.params.type + '_' + this.$store.state.project.id);
      this.fetchReports()
      this.dialogVisibleFilter = false
    },
    setChecks(d) {
      this.reports = this.reports.map((report) => {
        return {
          ...report,
          isChecked: d
        }
      })
    },
    async updateApprove() {

      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || firebase.auth().currentUser.uid)
        .get()
        .then(async (data) => {
          let user = null

          data.forEach((subDoc) => {
            user = subDoc.data();
          });


          let batch = firebase.firestore().batch();
          this.reports.filter((report) => report.isChecked).forEach((doc) => {
            const docRef = firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('reports')
              .doc(doc.id);
            batch.update(docRef, {
              approve: !doc.approve,
              approveUser: (!doc.approve) ? {name: user.name || firebase.auth().currentUser.email, uid: firebase.auth().currentUser.uid} : null
            });
          });
          await batch.commit();
          this.fetchReports();
        })
    },
    lockHide() {
      setTimeout(() => {
        this.lockNavigate = false
      }, 800)
    },
    toReport(report) {
      if (this.lockNavigate) {
        return
      }
      this.$router.push(`/dashboard/reports/create/${report.id}/${report.type}`);
    },
    isReportEnabledByPlan,
    searchInput: _.debounce(function (el, binding) {
      this.fetchReports();
    }, 500),
    closeDialog() {
      setTimeout(() => {
        this.openDialog = false;
        this.type_select = null;
        this.downloadWithPrice = false;
        this.isLaborIntensity = false;
        this.isProfession = false;
        this.isExecutor = false;
        this.downloadForAll = false;
        this.dayTurn = {
          label: 'Весь день',
          value: null,
        }
      }, 10);
    },
    sliceJob(jobs) {
      if (this.$route.params.type === 'COVID') {
        return [
          jobs,
        ];
      } else {
        return jobs ? jobs.slice(0, 3) : [];
      }
    },
    selectUser() {
      let query = {
        ...this.$route.query,
      };
      if (!this.userSelect || !this.userSelect.value) {
        delete query.user;
      } else {
        query = {
          ...this.$route.query,
          user: JSON.stringify(this.userSelect),
        };
      }
      // this.$router.push({
      //   path: this.$route.path,
      //   query: {
      //     ...query,
      //   },
      // });
    },
    fetchUsers() {
      this.loader = true;
      return new Promise((resolve, reject) => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .get()
          .then(async (data) => {
            const result = [{label: 'Все пользователи', value: null, isCompany: 1}];
            await data.forEach((subDoc) => {
              let _data = subDoc.data();
              result.push({
                label: _data.name || _data.email,
                value: _data.uid,
                isCompany: _data.isCompany ? 1 : 0,
                _data: _data
              });
            });

            this.options = _.orderBy(_.unionBy(result, 'label'), ['isCompany'], ['desc']);
            resolve();

          }).finally(() => {
          resolve();
          this.loading = false;
        }).catch((e) => {
          this.loading = false;
        });
      })
    },
    changeDateTime() {
      localStorage.setItem(this.$route.params.type + '_' + this.$store.state.project.id, JSON.stringify(this.filter));
      this.fetchReports();
    },
    sendReport() {
      const proxy = firebase.functions().httpsCallable(`onGenerateLogCommonJobs/${this.$store.state.project.id}`);
      proxy().then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отчет отправлен вам на почту',
          type: 'success',
        });
      }).catch(() => {
        this.$notify({
          offset: 60,

          title: 'Ошибка',
          message: 'Произошла ошибка, попробуйте позже',
          type: 'error',
        });
      });
    },
    navigate(report) {
      this.$router.push(
        `/dashboard/reports/edit/${report.id}/${this.$route.params.type}`,
      );
    },
    async fetchReports() {

      localStorage.setItem(this.$route.params.type + '_' + this.$store.state.project.id, JSON.stringify(this.filter));

      let query = firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports');

      const filterArray = [
        ['type', '==', this.$route.params.type],
      ];

      if (this.search) {
        filterArray.push(
          ['index', '==', Number(this.search)],
        );
      }

      if (this.$store.state.company.uid) {
        filterArray.push(
          ['userId', '==', this.$store.state.company.uid],
        );
      }

      if (this.$route.query.start && this.$route.query.end) {
        filterArray.push(
          ['dateunix', '<', formatEndDate(this.$route.query.end)],
        );
        filterArray.push(
          ['dateunix', '>', formatStartDate(this.$route.query.start)],
        );
      } else {
        filterArray.push(
          ['dateunix', '<', formatEndDate(this.filter.datetimeRange[1])],
        );
        filterArray.push(
          ['dateunix', '>', formatStartDate(this.filter.datetimeRange[0])],
        );
      }

      query = filterArray.reduce((accQuery, filter) => {
        return accQuery.where(filter[0], filter[1], filter[2]);
      }, query).orderBy('dateunix', 'desc');

      query.get()
        .then(async (data) => {
          const result = [];
          this.reports = [];

          data.forEach((subDoc) => {
            const data = subDoc.data()
            // console.log(data.reporter, 'data.reporter', this.filter.user.value, 'this.filter.user.value')


            if (this.role === 'worker' &&
              (data.reporter.uid !== firebase.auth().currentUser.uid && data.userId !== firebase.auth().currentUser.uid)
            ) {
              return
            } else {
              if (this.permission && this.permission.available_objects && !data.isWorkOrder && (data.reporter.uid !== firebase.auth().currentUser.uid && data.userId !== firebase.auth().currentUser.uid)) {
                const objects = this.objects.map(({value}) => value)

                if (!data.object || !data.object.id || !objects.includes(data.object.id)) {
                  return
                }
              }
            }


            if (this.filter.user && this.filter.user.value) {
              if (data.reporter.uid !== this.filter.user.value) {
                return false
              }
            }


            let user = this.filter.executor
            if (this.filter.executor && this.filter.executor.value) {
              const company = this.options.find((d) => d.value === user.value && d.isCompany);

              if (data.user.uid !== user.value && (!company || !company._data || company._data.company !== data.user.company)) {
                return
              }
            }


            // if(this.filter.executor && this.filter.executor.value) {
            //   if(data.user.uid !== this.filter.executor.value) {
            //     return false
            //   }
            // }

            if (this.filter.status) {
              if (data.approve && this.filter.status === 'NOT_APPROVE') {
                return false
              }

              if (!data.approve && this.filter.status === 'APPROVE') {
                return false
              }
            }

            if (this.filter.objects && this.filter.objects.length) {
              const objects = this.filter.objects.map(({value}) => value)
              if (!objects.includes(null)) {
                if (!data.object || !data.object.id || !objects.includes(data.object.id)) {
                  return
                }
              }
            }

            let planId = data.planId;

            if (!planId) {
              try {
                planId = data.jobs[0].job.planID;
              } catch (e) {
                try {
                  planId = data.jobs[0][0].job.planID;
                } catch (e) {
                }
              }
            }

            if (data.planId === undefined) {
              return result.push({
                ...data,
                index: data.index,
                id: subDoc.id,
                object: data.object && data.object.name,
                date: dayjs(data.datetime.substring(0, data.datetime.indexOf('+'))).format('DD/MM/YY'),
                jobs: data.jobs,
              });
            }


            if (this.$store.state.project.plan && planId === this.$store.state.project.plan.id) {
              return result.push({
                ...data,
                index: data.index,
                id: subDoc.id,
                object: data.object && data.object.name,
                date: dayjs(data.datetime.substring(0, data.datetime.indexOf('+'))).format('DD/MM/YY'),
                jobs: data.jobs,
              });
            }

            if ((!this.$store.state.project.plan || !this.$store.state.project.plan.id) && !planId) {
              return result.push({
                ...data,
                index: data.index,
                id: subDoc.id,
                object: data.object && data.object.name,
                date: dayjs(data.datetime.substring(0, data.datetime.indexOf('+'))).format('DD/MM/YY'),
                jobs: data.jobs,
              });
            }
          });

          if (this.role === 'editor') {
            const usersIds = await getMyCompanyUsers(this.$store.state.project.id);
            this.reports = result.filter((r) => usersIds.includes(r.userId) || usersIds.includes(r.reporterId) || usersIds.includes(r.company));
          } else {
            this.reports = result;
          }

          const savedReports = _.orderBy(this.reports, ['internalIndex'], ['asc']);
          this.reports = savedReports.map((report) => {
            report.objects = []
            const internal = this.reports.filter(({
                                                    id,
                                                    index,
                                                    object
                                                  }) => index === report.index && id !== report.id && report.object !== object);

            if (internal) {
              const objects = _.orderBy(internal, ['internalIndex'], ['asc'])
              report.objects = objects.map(({object}) => object)
            }

            return report
          })

          this.reports = _.orderBy(_.orderBy(this.reports.map((report) => {
            return {
              ...report,
              dateunix: dayjs(dayjs(report.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix()
            }
          }), ['index'], ['desc']), 'dateunix', ['desc']);
        });
    },
  }
};
</script>

<style scoped lang="scss">
.reports-index {
  margin: 0 auto;
  max-width: 1024px;
  padding-top: 20px;
}

.reports-ul {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.input-search {
  margin-top: 10px;
}

.reports-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
  padding: 10px 14px;
  text-decoration: none;
  color: #000;

  span {
    text-align: left;
  }

  &--child {
    width: 100%;
    display: flex;
    text-decoration: none;
    cursor: pointer;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;

  }

  .header-id {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    width: 100%;
  }

  span {
    font-size: 14px;
    color: #2c3e50;
  }

  span:first-child {
    margin-right: 20px;
  }


  span {
    margin-right: 5px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

> > > .el-date-editor--daterange.el-input__inner {
  width: 100%;
  margin-top: 10px;
}

.add-block {
  button {
    width: 100%;
    margin-top: 10px;
  }
}

.search-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 260px;

  .input-search {
    margin-right: 10px;
    min-width: 260px;
  }

  .filter-btn {
    margin-top: 10px;
    margin-left: 10px;
  }
}

.create-new {
  display: flex;
  justify-content: flex-start;
}

.jobs-list {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 764px) {
  .filter-dialog-button {
    width: 100% !important;
  }
  .search-filter {
    flex-direction: column;

    .filter {
      width: 100%;
    }
  }

  .filter-btn {
    width: 100%;
    margin-left: 0 !important;

    button {
      width: 100%;
    }
  }
  .reports-index {
    padding: 0 10px;
  }

  .search-filter .input-search {
    margin-right: 0;
  }

  .filter-worker {
    width: auto;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-select {
      width: 100%;
    }
  }
}

.create-new {
  display: flex;
  justify-content: space-between;
}

.filter {
  min-width: 260px;
}

.filter-worker {
  margin-top: 10px;
  margin-right: 5px;
}

.disabled {
  opacity: 0.7;
}

.mb-1 {
  margin-bottom: 10px;
}


.create-new {
  display: flex;
  align-items: center;

  .add-block button {
    margin-top: 0 !important;
  }
}

.type-create {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  i {
    margin-left: 16px;
    font-size: 28px;
    cursor: pointer;
  }
}

.el-icon-success {
  color: #2ecc71;
}
</style>
<style lang="scss">
.reports-index {
  .mx-datepicker-range {
    width: 100%;
    margin-top: 10px;

    .mx-input {
      border: 1px solid #DCDFE6;
      height: 40px;
    }
  }
}


.search-filter {
  .filter-worker {
    width: 100%;

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/Type.vue